import React from 'react';
import { TeachingFlow } from './TeachingFlow';
import { systemFlow } from '../../data/content';

/** Introduces the product and its six-stage pathway. */
export function SystemSection() {
  return <section aria-labelledby="system-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-148" data-mp="34avi2oy6ft3n">
      <div className="mx-auto max-w-4xl text-center" data-id="element-149" data-mp="398nb5mak5l9f">
        <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold" data-id="element-150" data-mp="39bjb1g5yuk0i">
          Meet Your New Teaching System
        </p>
        <h2 id="system-heading" className="mt-4 font-display font-bold leading-[0.95] text-brand-charcoal" data-id="element-151" data-mp="5rolmwocl4nk">
          <span className="block text-[2.3rem] uppercase sm:text-[3.2rem]" data-id="element-152" data-mp="3n8ev03nr9vvc">Makeup Instructor</span>
          <span className="block text-[3.2rem] italic text-brand-gold sm:text-[4.4rem]" data-id="element-153" data-mp="3s6zx68mkipmf">Ready</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[16px] font-semibold leading-relaxed text-brand-charcoal/80 sm:text-[17px]" data-id="element-154" data-mp="jqwrg8f0nb0q">
          Everything You Need to Plan, Teach, Practice, Assess & Manage Makeup Education.
        </p>

        <p className="mx-auto mt-8 w-fit rounded-full bg-brand-plum px-5 py-2 font-body text-[12px] font-bold uppercase tracking-[0.16em] text-white" data-id="element-155" data-mp="2myv7ix8bsaer">
          6 Core Professional Volumes
        </p>

        <TeachingFlow steps={systemFlow} size="lg" className="mt-10" data-id="element-156" data-mp="2r2un9dls7572" />

        <p className="mx-auto mt-6 max-w-xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-157" data-mp="2r1jipbkihtew">
          Each volume solves a different part of makeup education. Together, they create one connected
          teaching workflow you can return to class after class.
        </p>
      </div>
    </section>;
}